interface Props {
  color?: string;
  scale?: number;
}

const TrianglesOne = ({
  color = 'black',
  scale = 1,
}: Props) => {
  return (
    <svg
      width="100%"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 500 ${100 * scale}`}
    >
      <g transform={`scale(1, ${scale})`}>
        <path fill={color} d="M500 100H0V57L500 100Z" fillOpacity="0.15" />
        <path fill={color} d="M500 100H0L500 0V100Z" fillOpacity="0.5" />
        <path fill={color} d="M500 100H0L150.352 69.9303L500 100Z" />
      </g>
    </svg>
  );
};

export default TrianglesOne;
